var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgUserSpinnerArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0a3.93 3.93 0 0 0-1 7.72A6 6 0 0 1 10.77 5a3.8 3.8 0 0 0 .17-1.07A3.93 3.93 0 0 0 7 0M5.3 9.12h-.8a4.52 4.52 0 0 0-4.5 4.5A2.3 2.3 0 0 0 0 14h5.81A6 6 0 0 1 5 11a6.2 6.2 0 0 1 .3-1.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 11a3.6 3.6 0 1 1-3.66-3.59V6A5 5 0 1 0 16 11z",
    className: "secondary"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.123 11.903 1.59-1.603H9.78a.7.7 0 1 1 0-1.4h2.64a.7.7 0 0 1 .7.7v2.618a.7.7 0 1 1-1.4 0v-.91l-1.59 1.589a.7.7 0 0 1-.987-.987z",
    className: "arrow"
  })));
});